import request from '@/utils/request'

const http = request()

export const listRecords = params => http.post('/sys/fincate/list', params)

export const saveRecord = params => http.raw('/sys/fincate/save', params)

export const delRecord = id => http.post('/sys/fincate/delete', { id })
